import qs from 'query-string';

export const queryString = (options, props) => {
  return qs.stringify({ ...options } ,  { ...props, skipNull: true });
};